<template>
  <div class='animated fadeIn'>
    <b-row>
      <b-col lg='12'>
        <b-card title="<b>Site</b> List" sub-title="" v-if="$route.name === 'Sites'">
          <b-row>
            <b-col lg='4' md='6'>
            </b-col>
            <b-col lg='2' md='2'>
            </b-col>
            <b-col lg='6' md='4' class="text-right">
              <b-button href="#/settings/sites/create" size="lg" class="btn-rounded mb-3" variant="success">
                <i class="fa fa-plus"></i>
              </b-button>
            </b-col>
          </b-row>

          <c-server-table
            :url="apiUrl"
            :columns="columns"
            :options="options"
            ref="dataTable"
            >
          </c-server-table>

        </b-card>

        <router-view></router-view>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>
</template>

<script>
import cServerTable from '@/views/components/cServerTable'

export default {
  name: 'userIndex',
  components: {
    cServerTable
  },
  data () {
    // table config
    let config = cServerTable.methods.setTableConfig({
      columns: [
        'name',
        'description',
        'isAvailable',
        'actionButtons'
      ],
      options: {
        headings: {
          isAvailable: 'Available',
          actionButtons: ''
        },
        sortable: ['name'],
        uniqueKey: 'uuid',
        params: {},
        templates: {
          openTime (h, row) {
            return window.setDefaultNull(row.openTime, '-')
          },
          closedTime (h, row) {
            return window.setDefaultNull(row.closedTime, '-')
          }
        }
      }
    }, 'site')

    // data returned
    return {
      apiUrl: window.AppConfig.apiUrl + 'site',
      // vue-table-2 config
      columns: config.columns,
      options: config.options,
      // filter var
      filterBy: {
        available: '1'
      }
    }
  },
  mounted () {
  },
  methods: {
    doFilter () {
      this.options.params.avaiable = this.filterBy.available === '1' ? null : this.filterBy.available
      this.$refs.dataTable.setTableDatas()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/settings/facility/Index.vue